export {RootNavigator} from './RootNavigator';
